export default "__VITE_ASSET__D_IMK4nb__"